// WORDSY

// Game Status
export const GAME_WON = 'win'
export const GAME_LOST = 'lose'
export const GAME_WARNING = 'warning'

// Character Status
export const CHAR_CORRECT = 'correct'
export const CHAR_ABSENT = 'absent'
export const CHAR_PRESENT = 'present'
